import { render, staticRenderFns } from "./WhatIsWhitePollutionView.vue?vue&type=template&id=60006c98&scoped=true&"
import script from "./WhatIsWhitePollutionView.vue?vue&type=script&lang=js&"
export * from "./WhatIsWhitePollutionView.vue?vue&type=script&lang=js&"
import style0 from "./WhatIsWhitePollutionView.vue?vue&type=style&index=0&id=60006c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60006c98",
  null
  
)

export default component.exports